import {DownCircleOutlined, RetweetOutlined, CloseCircleOutlined} from '@ant-design/icons';
import {Link} from "react-router-dom";

const statusIcon = {
    pending: <RetweetOutlined className="wait-icon"/>,
    verified: <DownCircleOutlined className="accepted-icon"/>,
    rejected: <CloseCircleOutlined className="rejected-icon"/>,
};

export const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: "name",
        sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: "status",
        width: '8%',
        filters: [
            {
                text: 'Pending',
                value: 'pending',
            },
            {
                text: 'Verified',
                value: 'verified',
            },
            {
                text: 'Rejected',
                value: 'rejected',
            },
        ],
        onFilter: (value, record) => record.status === value,
        render: (text) => <div className="table-status">{statusIcon[text]}</div>,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: "email",
        sorter: (a, b) => a.email.localeCompare(b.email),
        width: '12%',
        responsive: ['lg'],
    },
    {
        title: 'Phone number',
        dataIndex: 'phone',
        key: "phone",
        sorter: (a, b) => a.phone.localeCompare(b.phone),
        width: '16%',
        responsive: ['lg'],
    },
    {
        title: 'Country',
        dataIndex: 'address_country',
        key: 'address_country',
        sorter: (a, b) => a.address_country.localeCompare(b.address_country),
        width: '8%',
        responsive: ['lg'],
    },
    {
        title: 'City',
        dataIndex: 'address_city',
        key: 'address_city',
        width: '8%',
        responsive: ['xl'],
        sorter: (a, b) => a.address_city.localeCompare(b.address_city),
    },
    {
        title: '# Missions complete',
        dataIndex: 'missions',
        key: 'missions',
        width: '12%',
        sorter: (a, b) => a.missionsComplete - b.missionsComplete,
        render: (_, {id, name, missionsComplete}) => {
            const total = `${missionsComplete} mission${missionsComplete > 1 ? "s" : ""}`;

            return missionsComplete ? <Link to={`/missions?user_id=${id}&name=${name}`} className="user-link">{total}</Link> : <span>{total}</span>;
        },
    },
    {
        title: '$ value',
        dataIndex: 'value',
        key: 'value',
        width: '8%',
        responsive: ['lg'],
        sorter: (a, b) => a.totalValue - b.totalValue,
        render: (_, record) => record.totalValue,
    },
    // {
    //     title: '',
    //     dataIndex: 'details',
    //     width: '12%',
    // },
];
